export function hasMarketplacePreparationOrders(items = []) {
  return items.some((item) => item.is_marketplace);
}
